/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/canvas_country_performance/:workflow_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdCanvasCountryPerformanceWorkflowId } from "./constants";
import type {
  GetEngagementAppGroupIdCanvasCountryPerformanceWorkflowIdProps,
  GetEngagementAppGroupIdCanvasCountryPerformanceWorkflowIdResult,
} from "./types";
import { isGetEngagementAppGroupIdCanvasCountryPerformanceWorkflowIdResult } from "./validators";

export const getEngagementAppGroupIdCanvasCountryPerformanceWorkflowId = reactQueryFetcherAdapter(
  engagementAppGroupIdCanvasCountryPerformanceWorkflowId,
  (
    signal: AbortSignal,
    { appGroupId, workflowId, startDate, endDate }: GetEngagementAppGroupIdCanvasCountryPerformanceWorkflowIdProps
  ): Promise<GetEngagementAppGroupIdCanvasCountryPerformanceWorkflowIdResult> => {
    return fetch(
      `/engagement/${appGroupId}/canvas_country_performance/${workflowId}`,
      "GET",
      { start: startDate, end: endDate },
      { signal }
    );
  },
  isGetEngagementAppGroupIdCanvasCountryPerformanceWorkflowIdResult
);
